import { render, staticRenderFns } from "./group.vue?vue&type=template&id=60c87638&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=60c87638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c87638",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CheckboxForm: require('/var/www/components/checkbox/checkbox-form.vue').default,TippyQuestion: require('/var/www/components/tippy/tippy-question.vue').default})
